import { FC } from "react";
import "./styles.css";
import JackPotText from "../../../assets/jackpot-text.png";

interface JackpotCardProps {
  jackpot: number;
}

const JackpotCard: FC<JackpotCardProps> = ({ jackpot }) => {
  return (
    <div className="d-flex flex-column justify-content-center">
      <img src={JackPotText} alt="Jackpot Text" />
      <div className="jackpot-card d-flex justify-content-center">
        <h1 className="my-auto">
          {jackpot.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </h1>
      </div>
    </div>
  );
};

export default JackpotCard;
